import { Avatar, makeStyles, Tooltip } from '@material-ui/core';
import React from 'react';
import { Inbox } from 'store/models/Inboxes';
interface InboxAvatarProps {
  inbox: {
    address: string;
    color: string;
  };
}

const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    fontSize: '13px',
  },
}));

const InboxAvatar: React.FC<InboxAvatarProps> = ({ inbox }) => {
  const classes = useStyles();
  //   if (!inbox) return <Avatar />;
  return (
    <Tooltip title={inbox?.address}>
      <Avatar
        className={classes.small}
        style={{ backgroundColor: inbox && `${inbox.color}` }}
      >
        {new Inbox(inbox).getLetterToShowInAvatar()}
      </Avatar>
    </Tooltip>
  );
};

export default InboxAvatar;
